import React from 'react';

// Ids de dbo.Estado (Intranet.Common.Enums.Estado). Se indexa por id y no por texto: el backend
// enmascara algunos textos según el rol (p. ej. Validado se ve como "Pendiente" para el colaborador).
const ESTADO_PENDIENTE = 10;
const ESTADO_VALIDADO = 8;
const ESTADO_OBSERVADO = 13;
const ESTADO_CERRADO = 7;
const ESTADO_COMPLETADA = 9;
const ESTADO_FINALIZADO = 19;

const ESTILO_FINALIZADO = { background: '#d9f6e6', border: '#a9e5c2', color: '#1a7f4b' };

// `etiqueta` reemplaza al texto del backend dentro de la pastilla; `leyenda` es el texto pequeño de abajo.
const ESTADO_PROCESO_ESTILOS = {
    [ESTADO_PENDIENTE]: { background: '#fde2e2', border: '#f6b8b8', color: '#c0262d', leyenda: 'Pendiente por líder' },
    [ESTADO_VALIDADO]: { background: '#ff6a00', border: '#ff6a00', color: '#ffffff', leyendaColor: '#b85c00', leyenda: 'Pendiente firma del colaborador' },
    [ESTADO_OBSERVADO]: { background: '#fff3c4', border: '#f2dc7e', color: '#8a6100' },
    [ESTADO_COMPLETADA]: { ...ESTILO_FINALIZADO, etiqueta: 'Completado' },
    [ESTADO_FINALIZADO]: ESTILO_FINALIZADO,
    [ESTADO_CERRADO]: ESTILO_FINALIZADO,
};

const ESTILO_NEUTRO = { background: '#f0f0f0', border: '#dcdcdc', color: '#555' };

/**
 * Pastilla de color con el estado y, debajo, la leyenda de qué falta (si aplica).
 * Mismo formato que los estados de postulación de Traslados y Promociones.
 */
const EstadoProcesoBadge = ({ idEstado, estado }) => {
    const { background, border, color, etiqueta, leyenda, leyendaColor } = ESTADO_PROCESO_ESTILOS[idEstado] ?? ESTILO_NEUTRO;

    return (
        <div>
            <span style={{
                display: 'inline-block',
                padding: '3px 14px',
                borderRadius: '14px',
                border: `1px solid ${border}`,
                fontSize: '0.85em',
                fontWeight: 700,
                background,
                color
            }}>
                {etiqueta ?? estado}
            </span>
            {leyenda &&
                <small className="d-block mt-1" style={{ color: leyendaColor ?? color, fontWeight: 500 }}>
                    {leyenda}
                </small>
            }
        </div>
    );
};

export default EstadoProcesoBadge;
